var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative follow-item"},[_c('img',{attrs:{"src":require("@/assets/img/follow.png"),"alt":""}}),_c('div',{staticClass:"absolute inset-0 overlay-content"},[_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }